export default {
  LOAD_COURSES (state, payload) {
    state.courses = payload
  },
  LOAD_ICAL_FILE (state, payload) {
    state.iCalFile = payload
  },
  DELETE_COURSE (state, payload) {
    state.courses.splice(state.courses.indexOf(payload), 1)
  },
  LOAD_STREAMS (state, payload) {
    state.streams = payload
  },
  LOAD_COURSE_PLANNING_STREAM (state, payload) {
    state.coursePlanningStream = payload
  },
  CLEAR_COURSES (state) {
    state.courses = []
  },
  UPDATE_SEMESTER_TIME_STAMP (state, payload) {
    state.lastUpdatedTime = payload
  }
}



// WEBPACK FOOTER //
// ./src/app/semester/vuex/mutations.js